import { SortDirection } from '@payaca/types/listViewTypes';
import UntitledIcon from '@payaca/untitled-icons';
import { FunctionComponent, type JSX } from 'react';

import './SortDirectionControl.sass';

type Props = {
  selectedSortDirection?: SortDirection;
  onChange: (sortDirection: SortDirection) => void;
};

const SortDirectionControl: FunctionComponent<Props> = ({
  selectedSortDirection,
  onChange,
}: Props): JSX.Element => {
  return (
    <div className="sort-direction-control">
      <UntitledIcon
        name="chevron-up"
        className={
          selectedSortDirection === SortDirection.ASCENDING ? 'active' : ''
        }
        onClick={() => {
          onChange(SortDirection.ASCENDING);
        }}
      />
      <UntitledIcon
        name="chevron-down"
        className={
          selectedSortDirection === SortDirection.DESCENDING ? 'active' : ''
        }
        onClick={() => {
          onChange(SortDirection.DESCENDING);
        }}
      />
    </div>
  );
};

export default SortDirectionControl;
